import { Head, Link } from "@inertiajs/react";
import { Chat } from "../../types/serializers";

export default function ChatShow({ chat }: { chat: Chat }) {
  debugger;
  return (
    <>
      <Head title="Inertia + Vite Ruby + React Example" />
      <h1>Chat {chat.id}</h1>

      <div>
        {chat["messages"]}
        {/*{chat.messages.map((message) => (
          <div key={message.id}>
            <p>{message.content}</p>
            <p>{message.created_at}</p>
          </div>
        ))}*/}
      </div>
    </>
  );
}
